import { MsisdnProcedureInterface } from '../../models/msisdn-procedure.interface';

export interface MsisdnProcedureInterfaceState {
  msisdnProcedures: Array<MsisdnProcedureInterface>;
}

export const initialMsisdnProcedureState: MsisdnProcedureInterfaceState = {
  msisdnProcedures: null
};
